import { render } from "./ThreeDPrinting.vue?vue&type=template&id=6383eae0&scoped=true"
import script from "./ThreeDPrinting.vue?vue&type=script&lang=js"
export * from "./ThreeDPrinting.vue?vue&type=script&lang=js"

import "./ThreeDPrinting.vue?vue&type=style&index=0&id=6383eae0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6383eae0"]])

export default __exports__